import type { SVGProps } from "react";
export interface CctvIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CctvIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CctvIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 21v-3a1.125 1.125 0 0 1 2.25 0v.375h2.353l.136-.01a.88.88 0 0 0 .685-.565l.42-1.148-1.524-.554-.106-.045a1.126 1.126 0 0 1 .766-2.104l.11.034 5.168 1.88a1.126 1.126 0 0 1-.769 2.116l-1.53-.558-.42 1.154a3.13 3.13 0 0 1-2.692 2.04l-.244.01H3.125V21a1.125 1.125 0 1 1-2.25 0M3.016 5.593a4.126 4.126 0 0 1 5.288-2.465l12.53 4.562a1.622 1.622 0 0 1 .799 2.418l.097.035a2.125 2.125 0 0 1 1.333 2.517l-.063.206-1.027 2.82a2.125 2.125 0 0 1-2.723 1.27l-2.231-.811a1.62 1.62 0 0 1-1.746.428L4.798 12.76a4.127 4.127 0 0 1-2.466-5.288l.684-1.88Zm15.446 8.681 1.44.525.939-2.584-.632-.23zM7.534 5.244a1.874 1.874 0 0 0-2.402 1.12l-.684 1.88a1.874 1.874 0 0 0 1.12 2.402L15.611 14.3l3.653-4.788z"
      />
    </svg>
  );
}
